import { apiGet } from './client';
import type { BossRankingsResponse } from './types';

export interface BossRankingFilters {
  serverId?: number;
  rankingPartitionId?: string;
  characterClass?: string;
  officialOnly?: boolean;
  guildId?: string;
  limit?: number;
  metric?: 'DAMAGE' | 'HEALING';
}

function queryString(filters: BossRankingFilters) {
  const params = new URLSearchParams();
  if (filters.serverId) params.set('serverId', String(filters.serverId));
  if (filters.rankingPartitionId) params.set('rankingPartitionId', filters.rankingPartitionId);
  if (filters.characterClass) params.set('characterClass', filters.characterClass);
  if (filters.officialOnly !== undefined) params.set('officialOnly', String(filters.officialOnly));
  if (filters.guildId) params.set('guildId', filters.guildId);
  if (filters.limit) params.set('limit', String(filters.limit));
  if (filters.metric) params.set('metric', filters.metric);
  const text = params.toString();
  return text ? `?${text}` : '';
}

export async function fetchBossRankings(bossId: string, filters: BossRankingFilters = {}) {
  return apiGet<BossRankingsResponse>(`/rankings/boss/${encodeURIComponent(bossId)}${queryString(filters)}`);
}
